// ** React Imports
import {useEffect} from "react";

// ** Custom Imports
import HeroSection from "../components/HeroSection";
import Features from "../components/Features";
import AboutSection from "../components/AboutSection";
import StatsSection from "../components/StatsSection";
import TestimonialsSection from "../components/TestimonialsSection";
import News from "../components/News";
import ResultsSection from "../components/ResultsSection";
import ContactUs from "../components/ContactUs";

// ** React router imports
import {useLocation} from "react-router-dom";


const HomePage = () => {

    const location = useLocation();

    useEffect(() => {
        if (location.pathname === "/") {
            const homeElement = document.getElementById("Home");
            if (homeElement) {
                homeElement.scrollIntoView({ behavior: "smooth" });
            } else {
                window.scrollTo(0, 0);
            }
        }
    }, [location]);

    return (
        <div>
            <HeroSection/>
            <Features/>
            <AboutSection/>
            <StatsSection/>
            <TestimonialsSection/>
            <News/>
            <ResultsSection/>
            <ContactUs/>
        </div>
    )
}

export default HomePage